import { QueryClient } from "@tanstack/react-query";

const queryClient = QueryClient;

export default queryClient;